/**
 * MENER À L'ONGLET MAINTENANCE D'UN APPAREIL, depuis n'importe quel écran
 * (spec 002, récit 1, EF-033 — 03/11/2026).
 *
 * « Ouvrir l'appareil » du calendrier ouvrait un panneau SANS ses maintenances,
 * et Mon jour ne menait pas à l'appareil du tout. L'adresse publiée est
 * `/equipements/<code>?onglet=maintenance` (`cheminMaintenanceAppareil`) ; ce
 * module fait le même trajet sans recharger la page : il ouvre le dossier et
 * DÉPOSE dans le magasin l'onglet (et l'échéance ou l'intervention) que le
 * dossier lira à son ouverture — puis effacera, pour qu'un retour ultérieur ne
 * le rouvre pas.
 *
 * Le dépôt passe par `onglets` du magasin, sous la clé `equip:<code>` : c'est
 * le registre fait pour « l'onglet demandé d'une fiche ».
 */
import { useGed } from './store';
import type { CibleMaintenance } from './maintenance-appareil';

export const cleOngletEquipement = (code: string) => `equip:${code}`;

/** Ce que le dossier d'un appareil doit ouvrir, déposé par un autre écran. */
export interface DemandeOngletEquipement extends CibleMaintenance { onglet: string }

export function lireDemandeOnglet(valeur: string | undefined): DemandeOngletEquipement | null {
  if (!valeur) return null;
  try {
    const d = JSON.parse(valeur) as DemandeOngletEquipement;
    return d && typeof d.onglet === 'string' ? d : null;
  } catch { return null; }
}

/** Ouvre le dossier de l'appareil sur son onglet Maintenance. `false` si
 *  l'appareil n'est pas (ou pas encore) au parc chargé. */
export function ouvrirMaintenanceAppareil(code: string, cible: CibleMaintenance = {}, origine = 'Retour'): boolean {
  const s = useGed.getState();
  const eq = (s.equips || []).find((x) => x.code === code);
  if (!eq) return false;
  s.setOnglet(cleOngletEquipement(code), JSON.stringify({ onglet: 'maintenance', ...cible }));
  s.fermerTousPanneaux();
  s.ouvrirDepuis(origine, { view: 'equip', cle: 'selectedEquip', valeur: eq.documentId });
  return true;
}

/** Ouvre le dossier de l'appareil sur un onglet donné (`examens`, `presentation`…) — même trajet, depuis le
 *  Référentiel ou l'annuaire (spec 002, récit 5). `false` si l'appareil n'est pas au parc chargé. */
export function ouvrirOngletAppareil(code: string, onglet: string, origine = 'Retour'): boolean {
  const s = useGed.getState();
  const eq = (s.equips || []).find((x) => x.code === code);
  if (!eq) return false;
  s.setOnglet(cleOngletEquipement(code), JSON.stringify({ onglet }));
  s.fermerTousPanneaux();
  s.ouvrirDepuis(origine, { view: 'equip', cle: 'selectedEquip', valeur: eq.documentId });
  return true;
}
